import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader, Text } from "@mantine/core";

function SignNow() {
  const { docGroupId = "" } = useParams();

  useEffect(() => {
    if (docGroupId) {
      // check that all documents are signed then post a message (remaining)
      window.parent.postMessage(
        { documentSigned: true },
        window.location.origin
      );
    }
  }, [docGroupId]);

  return (
    <>
      <Loader width={"100%"} mt={"xl"} sx={{ margin: "auto" }} />
      <Text fw={600} fs={"xl"} align="center" pt={"md"}>
        Please Wait Document is Verifying ...
      </Text>
    </>
  );
}

export default SignNow;
